import React, { useState } from 'react';

const FisherZTransformation = () => {
  const [correlation, setCorrelation] = useState('');
  const [zValue, setZValue] = useState(null);
  const [error, setError] = useState('');

  // Function to calculate the Fisher Z transformation
  const calculateZTransformation = (r) => {
    // Check if the correlation value is valid
    if (r >= -1 && r <= 1) {
      // Fisher Z-transformation formula
      const z = 0.5 * Math.log((1 + r) / (1 - r));
      setZValue(z);
      setError('');
    } else {
      setZValue(null);
      setError('Please enter a valid correlation coefficient between -1 and 1.');
    }
  };

  // Handle input change
  const handleInputChange = (e) => {
    const value = e.target.value;
    setCorrelation(value);

    // Ensure the input is a number and calculate the Fisher Z-transformation
    if (!isNaN(value)) {
      calculateZTransformation(parseFloat(value));
    } else {
      setZValue(null);
      setError('Invalid input. Please enter a numeric value for the correlation coefficient.');
    }
  };

  return (
    <div>
      <h2>Fisher's Z-Transformation for Correlation Coefficient</h2>
      <label htmlFor="correlationInput">Enter Correlation Coefficient (r): </label>
      <input
        type="number"
        id="correlationInput"
        value={correlation}
        onChange={handleInputChange}
        step="0.01"
        min="-1"
        max="1"
        placeholder="Enter a value between -1 and 1"
      />
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {zValue !== null && !error && (
        <div>
          <p><strong>Fisher Z-transformed value (z):</strong> {zValue.toFixed(4)}</p>
        </div>
      )}
    </div>
  );
};

export default FisherZTransformation;
